// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";

// Soft UI Dashboard PRO React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

function ComplexReportsDoughnutChartItem({ image, title, percentage, hasBorder }) {
  const { borderWidth } = borders;
  const { light } = colors;

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{ borderBottom: hasBorder ? `${borderWidth[1]} solid ${light.main}` : "none" }}
    >
      <Grid item xs={10}>
        <SoftBox display="flex" py={1.5} px={2}>
          {image && (
            <SoftBox mr={1}>
              <SoftAvatar src={image} size="sm" alt="title" />
            </SoftBox>
          )}
          <SoftBox
            display="flex"
            flexDirection="column"
            justifyContent="center"
            sx={{ maxWidth: "100%", overflow: "hidden" }}
          >
            <SoftTypography
              component="div"
              sx={{
                fontSize: "0.7rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              textTransform="capitalize"
              fontWeight="medium"
            >
              {title}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </Grid>
      <Grid item xs={2}>
        <SoftBox
          py={0.8}
          px={1}
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          textAlign="right"
        >
          <SoftTypography
            variant="button"
            fontWeight="medium"
            color="text"
            sx={{ fontSize: "0.75rem" }}
          >
            {percentage.split("·")[0].trim()}
          </SoftTypography>
          <SoftTypography
            variant="caption"
            fontWeight="regular"
            color="text"
            sx={{ fontSize: "0.7rem", mt: 0.5 }}
          >
            {percentage.split("·")[1]?.trim()}
          </SoftTypography>
        </SoftBox>
      </Grid>
    </Grid>
  );
}

// Setting default values for the props of ComplexReportsDoughnutChartItem
ComplexReportsDoughnutChartItem.defaultProps = {
  image: "",
  hasBorder: false,
};

// Typechecking props for the ComplexReportsDoughnutChartItem
ComplexReportsDoughnutChartItem.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  percentage: PropTypes.string.isRequired,
  hasBorder: PropTypes.bool,
};

export default ComplexReportsDoughnutChartItem;
